var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Promotion"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Promotion Type"}},[_c('promotion-type')],1),_c('vs-tab',{attrs:{"label":"Promotion Variable"}},[_c('div',{staticClass:"tab-text"},[_c('promotion-variable')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }